import { get as getProp, set as setProp } from 'dot-prop';

/** Deletes the property at @see key. */
export function deleteProp<T>(
  item: T,
  key: string
): void {
  const splitKey = key.split('.');
  const lastIndex = splitKey.length -1;
  const parentKey = splitKey.slice(0, lastIndex).join('.');
  const childKey = splitKey[lastIndex];

  const parentObject: unknown = (parentKey) ? (
    getProp(item, parentKey)
  ) : item;
  if (!parentObject) {
    return;
  }

  if (parentObject instanceof Array) {
    const childIndex = parseInt(childKey, 10);
    setProp(item, parentKey, parentObject.filter((_, index) => {
      return index !== childIndex;
    }));
  } else if (parentObject && typeof parentObject === 'object') {
    delete (parentObject as any)[childKey];
  }
}
